<template>
  <Modal
    name="CANCEL_APPOINTMENT_MODAL"
    :title="$t('appointment.cancelModal.title')"
  >
    <template v-slot:body>
      <v-progress-linear
        class="mt-5 mb-7"
        v-show="isAppointmentLoading"
        indeterminate
        rounded
      />

      <div v-show="!isAppointmentLoading">
        <p>{{ $t('appointment.cancelModal.confirmationQuestion') }}</p>

        <AppointmentFormDetails :appointment="appointment" />

        <v-form ref="appointmentFormCancel" v-model="valid">
          <v-row>
            <v-col cols="8">
              <v-select
                v-model="selectedCancelReason"
                :label="$t('appointment.cancelModal.cancelReason')"
                :items="cancelReasons"
                :rules="[rules.required]"
                item-text="description"
                item-value="id"
                outlined
                hide-details="auto"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <v-textarea
                v-model="reason"
                :label="$t('appointment.cancelModal.description')"
                :rules="[rules.minLength]"
                ref="cancelReason"
                hide-details="auto"
                outlined
                rows="3"
              />
            </v-col>
          </v-row>

          <v-row>
            <div class="mt-2 d-flex align-center">
              <HCheckbox
                class="mr-2"
                v-model="notifyPropertyManager"
                :label="$t('appointment.cancelModal.notifyPropertyManager')"
              />
              <InformationTooltip :message="$t('appointment.cancelModal.notifyPropertyManagerInfoMessage')" />
            </div>
          </v-row>

          <div class="mt-7 text-right">
            <v-btn
            @click="cancel"
              :loading="isLoading || isAppointmentCanceling"
              :disabled="!valid"
              elevation="0"
              color="error"
              large
            >
              {{ $t('appointment.cancelModal.cancel') }}
            </v-btn>
          </div>
        </v-form>
      </div>
    </template>
  </Modal>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

import { catalogDate } from '@/util/catalog'
import { minLength, required } from '@/util/errorHandling'

import Modal from '@/components/app/Modal'

import AppointmentFormDetails from './formFieldsReschedule/AppointmentFormDetails'
import HCheckbox from '../app/HCheckbox.vue'
import InformationTooltip from '../app/InformationTooltip.vue'

export default {
  name: 'AppointmentCancel',

  components: {
    Modal,
    AppointmentFormDetails,
    HCheckbox,
    InformationTooltip,
  },

  computed: {
    ...mapGetters([
      'isLoading',
      'appointment',
      'cancelReasons',
      'isAppointmentLoading',
      'isAppointmentCanceling',
    ]),

    isAdminOrPartner() {
      const roles = localStorage.getItem('access_roles')
      const userRoles = roles?.split(',')
      return userRoles?.includes('ROLE_ADMIN') || userRoles?.includes('ROLE_PARTNER')
    },
  },

  methods: {
    ...mapMutations([
      'closeAllModals',
    ]),
    ...mapActions([
      'fetchBoard',
      'fetchAppointment',
      'fetchCancelReasons',
      'cancelAppointment',
      'cancelAppointmentAsAdmin',
    ]),

    refreshAndClose() {
      if (this.$parent?.refreshMap) this.$parent?.refreshMap()
      if (this.$parent?.refreshAppointments) this.$parent?.refreshAppointments()
      this.closeAllModals()
    },

    cancel() {
      const cancelPayload = {
        id: this.appointment.id,
        cancelReason: this.reason,
        reasonCancelId: this.selectedCancelReason,
        form: this.$refs.appointmentFormCancel,
        realEstateId: this.appointment?.real_estate?.id ?? null,
        notifyPropertyManager: this.notifyPropertyManager,
      }

      if (this.isAdminOrPartner) {
        this.cancelAppointmentAsAdmin(cancelPayload).then(() => this.refreshAndClose())
      } else {
        this.cancelAppointment(cancelPayload).then(() => this.refreshAndClose())
      }
    },
  },

  data() {
    return {
      reason: null,
      formatDate: catalogDate,
      rules: {
        minLength,
        required,
      },
      valid: false,
      selectedCancelReason: null,
      notifyPropertyManager: false,
    }
  },

  async mounted() {
    await this.fetchCancelReasons(this.isAdminOrPartner)
  },
}
</script>
